'use client';

import React, { useMemo } from 'react';
import { buildEdgeIframeCheckoutUrl, type EdgeIframeCheckoutParams } from '../buildEdgeIframeCheckoutUrl';
import {
  PremiumCheckoutIframeModal,
  type IamOrderCompleteDetail,
  type PremiumCheckoutCloseResult,
} from './PremiumCheckoutIframeModal';

export type EdgeCheckoutModalProps = {
  checkoutParams: EdgeIframeCheckoutParams;
  onClose: (result?: PremiumCheckoutCloseResult) => void;
  onOrderComplete?: (detail: IamOrderCompleteDetail) => void;
  open: boolean;
  title?: string;
};

export const EdgeCheckoutModal: React.FC<EdgeCheckoutModalProps> = ({
  checkoutParams,
  onClose,
  onOrderComplete,
  open,
  title = 'Get Benzinga Edge',
}) => {
  const iframeSrc = useMemo(() => buildEdgeIframeCheckoutUrl(checkoutParams), [checkoutParams]);

  return (
    <PremiumCheckoutIframeModal
      iframeSrc={iframeSrc}
      onClose={onClose}
      onOrderComplete={onOrderComplete}
      open={open}
      title={title}
    />
  );
};
